import axios from 'axios';

import { getUrlParam } from '@tencent/vft-common/util.esm';

import * as reporter from './report';
import sign from './sign';;

const isDebug = Number(getUrlParam('debug') || getUrlParam('sandbox')) === 1;
const newLoginCgi = `https://${isDebug ? 't' : ''}pbaccess.video.qq.com/trpc.video_account_login.web_login_trpc.WebLoginTrpc`;

export function RequestError(code, msg, res) {
  this.code = code;
  this.msg = msg;
  this.res = res;
}

RequestError.prototype.toString = function () {
  return this.msg + (this.code ? `(${this.code})` : '');
};

export async function doRequest(cmd, params) {
  // 新登录接口协议文档：https://trpc.rick.woa.com/rick/pb/view_protobuf?id=57140
  const signInfo = await sign.getSignInfo();
  const { data: responseData, status, statusText } = await axios.post(`${newLoginCgi}/${cmd}`, {
    si: signInfo,
    ...params,
  }, {
    headers: {
      'Content-Type': 'application/json',
    },
    type: 'POST',
    timeout: 5000,
    withCredentials: true,
  });

  if (status !== 200) {
    throw new RequestError(status, statusText, responseData);
  }

  const { data, ret, msg } = responseData || {};
  if (ret !== 0 || !data) {
    throw new RequestError(ret, msg, data);
  }

  if (data.errcode !== 0) {
    throw new RequestError(data.errcode, data.err_msg, data);
  }

  return data;
}

export async function request(cmd, params) {
  const reportParams = {
    f_event: reporter.EVENT_INIT_REQUEST,
    f_cgi: cmd,
    f_cgi_param: JSON.stringify(params),
  };
  const startTime = Date.now();
  try {
    const data = await doRequest(cmd, params);
    reportParams.f_errcode = 0;
    reportParams.f_cost = Date.now() - startTime;
    reporter.report(reportParams);
    return data;
  } catch (e) {
    reportParams.f_errcode = e.code;
    reportParams.f_errmsg = e.msg;
    reportParams.f_cost = Date.now() - startTime;
    reporter.report(reportParams);
    throw e;
  }
}

/**
 * 登录换票
 * @returns
 */
export function authLogin(params = {}) {
  return request('NewLogin', params);
}

/**
 * 刷票据
 * @returns
 */
export function authRefresh(params = {}) {
  return request('NewRefresh', params);
}

/**
 * 退出登录
 * @returns
 */
export function authLogout(params = {}) {
  return request('NewLogout', params);
}

/**
 * 第三方登录换票
 * @param {String} type
 * @param {Object} params
 * @returns
 */
export async function thirdLogin(type, params) {
  const { data } = await axios.post(`//vip.video.qq.com/fcgi-bin/comm_cgi?name=third_login&otype=xjson&type=${type}`, params, {
    dataType: 'json',
    withCredentials: true,
    timeout: 2000,
  });
  return data;
}

/**
 * 校验登录态
 * @param {Object} params
 * @returns
 */
export async function checkLogin(params) {
  const { data } = await axios.get('//vip.video.qq.com/fcgi-bin/comm_cgi?name=check_login&otype=xjson', {
    params,
    withCredentials: true,
    timeout: 6000,
  });
  return data;
}
